// src/pages/StaffManagerPage.js

import React, { useState } from "react";

import StaffManager from "../components/principal/StaffManager";
import "../styles/PrincipalDashboard.css";
import "../styles/PrincipalDashboardPanels.css";

const StaffManagerPage = () => {
  const [error, setError] = useState("");

  return (
    <div className="principal-dashboard-container page">
      <header className="principal-dashboard-header">
        <div className="principal-dashboard-heading">
          <p className="principal-dashboard-eyebrow">School Settings</p>
          <h1 className="principal-dashboard-title">Bulk Staff Setup</h1>
          <p className="principal-dashboard-subtitle">
            Paste staff email addresses or upload a CSV/Excel file, then confirm the invites before they are sent.
          </p>
        </div>
      </header>

      {error ? (
        <p className="error-message" aria-live="polite">
          {error}
        </p>
      ) : null}

      <section className="principal-dashboard-main">
        <StaffManager onError={setError} />
      </section>
    </div>
  );
};

export default StaffManagerPage;
